const ChartBar = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-user"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-user"
      viewBox="0 0 72 68"
      width={_width}
      fill="none"
      {...props}
    >
      <path
        d="M27.4552 39.6665H12.6668C9.1835 39.6665 6.3335 42.2165 6.3335 45.3332V62.3332H27.4552V39.6665Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M42.2117 28.3335H33.7567C30.2733 28.3335 27.4233 30.8835 27.4233 34.0002V62.3335H48.545V34.0002C48.545 30.8835 45.7267 28.3335 42.2117 28.3335Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M63.3332 48.1665H48.5449V62.3332H69.6666V53.8332C69.6666 50.7165 66.8166 48.1665 63.3332 48.1665Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M39.6469 5.86499L41.3252 8.86831C41.5469 9.29331 42.1486 9.68997 42.6552 9.74664L45.6952 10.2C47.6269 10.4833 48.1019 11.7583 46.7086 12.9766L44.3336 15.1016C43.9219 15.4699 43.7002 16.15 43.8269 16.6316L44.4919 19.2383C45.0302 21.3067 43.7952 22.1 41.7686 21.0233L38.9186 19.5217C38.4119 19.2383 37.5569 19.2383 37.0502 19.5217L34.2002 21.0233C32.1736 22.1 30.9386 21.3067 31.4769 19.2383L32.1419 16.6316C32.2686 16.15 32.0469 15.4416 31.6352 15.1016L29.2919 13.005C27.8986 11.7583 28.3419 10.5116 30.3052 10.2283L33.3452 9.775C33.8519 9.69 34.4536 9.29334 34.6752 8.89667L36.3536 5.89326C37.2719 4.24993 38.7286 4.24999 39.6469 5.86499Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ChartBar;
